import { render, staticRenderFns } from "./mediastationSettings.vue?vue&type=template&id=0508532e&scoped=true&"
import script from "./mediastationSettings.vue?vue&type=script&lang=js&"
export * from "./mediastationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508532e",
  null
  
)

export default component.exports